import React from 'react';
import './CountrySelectionModal.css';

const CountrySelectionModal = ({ isOpen, onClose, onSelectCountry, availableCountries = [], canClose = false }) => {
  if (!isOpen) return null;

  const handleCountrySelect = (country) => {
    onSelectCountry(country);
  };

  const handleOverlayClick = (e) => {
    // Only allow closing if canClose is true
    if (canClose && e.target === e.currentTarget) {
      onClose();
    }
  };

  // Format country name to camelCase
  const formatCountryName = (country) => {
    if (!country) return '';
    const lower = country.toLowerCase();
    // Handle special cases
    if (lower === 'uae') return 'UAE';
    if (lower === 'india') return 'India';
    if (lower === 'singapore') return 'Singapore';
    // Default: capitalize first letter
    return country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
  };

  return (
    <div className={`country-modal-overlay ${!canClose ? 'required-selection' : ''}`} onClick={handleOverlayClick}>
      <div className="country-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="country-modal-header">
          <div className="country-modal-icon">🌍</div>
          <h2>Select Your Country</h2>
          <p>Choose your country to access region-specific earnings data</p>
        </div>
        
        <div className="country-modal-body">
          {availableCountries.length === 0 ? (
            <div className="country-loading">
              <div className="country-loading-spinner"></div>
              <p>Loading available countries...</p>
            </div>
          ) : (
            <div className="country-list">
              {availableCountries.map((country) => {
                const formattedName = formatCountryName(country);
                return (
                <button
                  key={country}
                  className="country-button"
                  onClick={() => handleCountrySelect(country)}
                >
                  <span className="country-flag">{getCountryFlag(country)}</span>
                    <span className="country-name">{formattedName}</span>
                    <span className="country-arrow">→</span>
                </button>
                );
              })}
            </div>
          )}
        </div>
        
        {canClose && (
          <div className="country-modal-footer">
            <button className="country-modal-close" onClick={onClose}>
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const getCountryFlag = (country) => {
  const flags = {
    'india': '🇮🇳',
    'India': '🇮🇳',
    'uae': '🇦🇪',
    'UAE': '🇦🇪',
    'singapore': '🇸🇬',
    'Singapore': '🇸🇬'
  };
  const lower = country?.toLowerCase();
  return flags[country] || flags[lower] || '🌍';
};

export default CountrySelectionModal;

